import { useMemo } from "react";
import _ from "underscore";

const empty = [];

const useMappedValue = ({
  multiselect,
  options,
  value,
  labelKey,
  valueKey,
  mappedOptions,
}) => {
  return useMemo(() => {
    if (!value) {
      if (multiselect) {
        return empty;
      }

      return null;
    }

    if (multiselect) {
      let filteredOptions = null;
      if (options.includes("Global.Lists.")) {
        filteredOptions = _.filter(mappedOptions, (opt) => {
          return _.findWhere(value, {
            [valueKey]: opt?.[valueKey],
            [labelKey]: opt?.[labelKey],
          });
        });
      } else {
        filteredOptions = _.filter(options, (opt) => {
          return _.findWhere(value, {
            [valueKey]: opt?.[valueKey],
            [labelKey]: opt?.[labelKey],
          });
        });
      }

      return filteredOptions?.length
        ? filteredOptions?.map((opt) => {
            return _.clone(opt);
          })
        : [];
    }

    let val = null;
    if (options.includes("Global.Lists.")) {
      val = _.findWhere(mappedOptions, {
        [valueKey]: value?.[valueKey],
        [labelKey]: value?.[labelKey],
      });
    } else {
      val = _.findWhere(options, {
        [valueKey]: value?.[valueKey],
        [labelKey]: value?.[labelKey],
      });
    }

    return val ? val : null;
  }, [multiselect, options, value, labelKey, valueKey, mappedOptions]);
};

export default useMappedValue;
